// Consts
// ----------------------------------------------------------------------------

export const DPR = window.devicePixelRatio || 1;

export const ZOOM = 75;

export const NOOP = () => {};

// Initials
// ----------------------------------------------------------------------------

export const INIT_STATE = {
  parallaxes: [],
  isEnabled: false,
  version: 0
};

export const INIT_CONTEXT = {
  ...INIT_STATE,
  addParallax: NOOP,
  removeParallax: NOOP,
  enable: NOOP,
  disable: NOOP,
  refresh: NOOP
};
